<template>
  <div class="new">
    <div class="title">
      <VTitle page-title="我的消息"></VTitle>
    </div>

    <div v-if="myNew.length" class="content">
      <VMyNew v-for="obj, index in myNew" :obj="obj" :key="index"></VMyNew>
    </div>

    <div v-else class="nothing">
      您还没有消息哦
    </div>

    <div class="back-wrapper">
      <VGoBackBtn></VGoBackBtn>
    </div>

  </div>
</template>

<script type="text/ecmascript-6">
  import Vue from 'vue';
  import VTitle from '../../components/VTitle.vue';
  import VMyNew from '../../components/VMyNew.vue';
  import VGoBackBtn from '../../components/VGoBackBtn.vue';
  import { InfiniteScroll } from 'mint-ui';
  import netTool from '../../api/netTool';
  import { mapGetters } from 'vuex';
  Vue.use(InfiniteScroll);

  export default {
    name: 'myNew',
    data () {
      return {
        myNew: []
      };
    },
    created() {
      this.Notice();
    },
    components: {VTitle, VMyNew, VGoBackBtn},
    methods: {
      Notice () {
        let schoolId = 0;
        let gradeId = 0;
        if (this.user.user_role.user_type === 1) {
          schoolId = this.user.user_role.school_id;
          gradeId = this.user.user_role.grade_id;
        } else {
          schoolId = this.school.school_id;
          gradeId = this.grade.grade_id;
        }
        let params = {
          'type': '1',
          school_id: schoolId,
          grade_id: gradeId
        };
        netTool.notice(params).then(response => {
          if (response.errno === '0') {
            this.myNew = response.result;
          } else {
            console.log(response.message);
          }
        })
          .catch(error => {
            console.log(error);
          });
      }
    },
    computed: {
      ...mapGetters({
        user: 'getUserInfo',
        school: 'school',
        grade: 'grade'
      })
    }
  };
</script>

<style scoped lang="scss" type="text/scss" rel="stylesheet/scss">
  @import '../../assets/scss/base.scss';
  $topColor: #e6c590;
  $bottomColor: #ddb375;
  .new {
    width: px2rem(750);
    @include line-gradient-top-to-bottom($topColor, $bottomColor);

    .nothing{
      height: px2rem(1334 - 240 - 161);
      box-sizing: border-box;
      padding: px2rem(60) 0 0 0;
      font-size: px2rem(30);
      text-align: center;
    }
  }

  .title {
    padding-top: px2rem(40 + 49);
    margin-bottom: px2rem(28);
    text-align: center;
  }

  .content {
    padding-left: px2rem(50);
    width: px2rem(655);
    height: px2rem(1334 - 240 - 161);
    overflow-y: scroll;
    overflow-x: hidden;
    -webkit-overflow-scrolling: touch;
  }

  .back-wrapper {
    margin-top: px2rem(-20);
  }


</style>



// WEBPACK FOOTER //
// MyNew.vue?cc2b6f68